import type { ComponentProps } from "react"
import { Suspense, lazy } from "react"
import { A, H1, H2, H3, H4, HR, P, Spinner, UL } from "@motleyhand/design"

const BaseMarkdown = lazy(() => import("markdown-to-jsx"))

type Props = Pick<ComponentProps<typeof BaseMarkdown>, "children">

export default function Markdown({ children }: Props) {
  return (
    <Suspense fallback={<Spinner />}>
      <BaseMarkdown
        options={{
          wrapper: "div",
          forceBlock: true,
          overrides: {
            h1: (props: ComponentProps<"h1">) => <H1 {...props} />,
            h2: (props: ComponentProps<"h2">) => <H2 {...props} />,
            h3: (props: ComponentProps<"h3">) => <H3 {...props} />,
            h4: (props: ComponentProps<"h4">) => <H4 {...props} />,
            p: (props: ComponentProps<"p">) => <P {...props} />,
            ul: (props: ComponentProps<"ul">) => <UL {...props} />,
            a: (props: ComponentProps<"a">) => <A {...props} />,
            hr: (props: ComponentProps<"hr">) => <HR {...props} />,
            // … TODO
          },
        }}
      >
        {children}
      </BaseMarkdown>
    </Suspense>
  )
}
